import axios from "axios";
import { jobPostUrl } from "../../utils";

export const fetchJobPost = async (jobPostId: string) => {
  return await axios.get(jobPostUrl(jobPostId));
};
